import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  sliderContent: {
    display: "grid",
    gridTemplateColumns: "5% 90% 5%",
    alignItems: "center",
    justifyItems: "center",
  },
  btnL: {
    display: "flex !important",
    alignContent: "center !important",
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  btnR: {
    gridColumn: "3/4",
  },
  arrows: {
    backgroundColor: "#997DB5 !important",
    borderRadius: "30px",
    color: "white",
    fontSize: "30px!important",
    display: "flex !important",
    alignContent: "center !important",
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  btn: {
    display: "flex!important",
    justifyContent: "center!important",
    textAlign: "center !important",

    "&:hover": {
      background: "none",
    },
  },
}));

export default useStyles;
